import { RootState } from '@/domain/store';

import { selectCurrentProjectTour } from '../project-tour/project-tour.selectors';
import { CalculateTour } from './entities/calculate-tour.entity';
import {
  CalculateTourCo2,
  EMPTY_CALCULATE_TOUR_CO2,
} from './entities/calculate-tour-co2.entity';
import {
  CalculateTourEnv,
  EMPTY_CALCULATE_TOUR_ENV,
} from './entities/calculate-tour-env.entity';
import {
  CalculateTourEss,
  EMPTY_CALCULATE_TOUR_ESS,
} from './entities/calculate-tour-ess.entity';

export const selectImpactCalculateTourForProject =
  (projectId: number) =>
  (state: RootState): CalculateTour | null => {
    const calculate = state.impactCalculateTour.byProjectId[projectId];
    if (calculate) {
      return calculate;
    } else {
      return null;
    }
  };

export const selectImpactCalculateTourForCurrentProject = (
  state: RootState,
): CalculateTour | null => {
  const project = selectCurrentProjectTour(state);
  const projectId = project?.id || -1;
  return selectImpactCalculateTourForProject(projectId)(state);
};

export const selectImpactCalculateTourCo2ForProject =
  (projectId: number) =>
  (state: RootState): CalculateTourCo2 => {
    const calculate = selectImpactCalculateTourForProject(projectId)(state);
    if (calculate?.co2) {
      return calculate.co2;
    } else {
      return EMPTY_CALCULATE_TOUR_CO2;
    }
  };

export const selectImpactCalculateTourEnvForProject =
  (projectId: number) =>
  (state: RootState): CalculateTourEnv => {
    const calculate = selectImpactCalculateTourForProject(projectId)(state);
    if (calculate?.env) {
      return calculate.env;
    } else {
      return EMPTY_CALCULATE_TOUR_ENV;
    }
  };

export const selectImpactCalculateTourEssForProject =
  (projectId: number) =>
  (state: RootState): CalculateTourEss => {
    const calculate = selectImpactCalculateTourForProject(projectId)(state);
    if (calculate?.ess) {
      return calculate.ess;
    } else {
      return EMPTY_CALCULATE_TOUR_ESS;
    }
  };

export const selectImpactResultsForTourEvent =
  (tourEventId: number) =>
  (state: RootState): { co2: number } => {
    const project = selectCurrentProjectTour(state);
    const projectId = project?.id || -1;
    const calculate = selectImpactCalculateTourForProject(projectId)(state);
    const co2 = calculate?.co2?.ontour?.byTourEvent[tourEventId]?.score || 0;
    return { co2 };
  };
